"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.mergeCommentProperties = exports.INITIAL_STATE = void 0;

var _reduxActions = require("redux-actions");

var _lodash = _interopRequireDefault(require("lodash.get"));

var _lodash2 = _interopRequireDefault(require("lodash.clonedeep"));

var _LocalStorageManager = _interopRequireDefault(require("../lib/LocalStorageManager"));

var _constants = require("../constants");

var _utils = require("../lib/utils");

var _handleActions;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var showAnnotations = (0, _utils.loadFromLocalStorage)('showAnnotations');
var INITIAL_STATE = {
  comments: [],
  commentsReceived: false,
  commentsGetting: false,
  commentsUpdated: false,
  dirtyComments: {},
  editingCommentId: '',
  editingReplyId: '',
  editingReplyParentCommentId: '',
  errors: {},
  filterTime: [],
  filterUsers: [],
  commentPosted: false,
  postingReplyParentCommentId: '',
  remappedMap: {},
  showAnnotations: showAnnotations === undefined ? true : showAnnotations,
  showResolvedComments: false
};
/**
 * Helper function to find an item by the ID field
 * @param {array} items - list of items to search
 * @param {string} id - id to use to search
 * @returns {object} item with matching ID
 */

exports.INITIAL_STATE = INITIAL_STATE;

var findItemById = function findItemById(items, id) {
  return items.find(function (item) {
    return item.id === id;
  });
};
/**
 * Helper function to handle remapping a comment to locally modified node IDs
 * @param {object} remappedMap - map of comment IDs to node information
 * @param {object} comment - comment to be remapped
 * @returns {object} updated comment object with remapped node
 */


var applyNodeRemap = function applyNodeRemap() {
  var remappedMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var comment = arguments.length > 1 ? arguments[1] : undefined;
  var currentComment = (0, _lodash2.default)(comment);

  if (remappedMap[comment.id] && (0, _lodash.default)(comment, 'target.selector.node.id') !== undefined) {
    currentComment.target.selector.node.id = remappedMap[comment.id].current;
  }

  return currentComment;
};
/**
 * Helper function to handle remapping comments to locally modified node IDs
 * @param {object} remappedMap - map of comment IDs to node information
 * @param {array} comments - comments to be remapped
 * @returns {array} updated comment object with remapped node
 */


var findAndRemapComments = function findAndRemapComments() {
  var remappedMap = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var comments = arguments.length > 1 ? arguments[1] : undefined;
  var currentComments = (0, _lodash2.default)(comments);
  Object.keys(remappedMap).forEach(function (key) {
    var currentComment = findItemById(currentComments, key);

    if (currentComment) {
      currentComment = applyNodeRemap(remappedMap, currentComment);
      currentComments.splice(currentComments.indexOf(findItemById(currentComments, currentComment.id)), 1, currentComment);
    }
  });
  return currentComments;
};
/**
 * Keep extra properties like repliesOpen from current comments and apply them to new comments
 * @param {array} currentComments - list of current comments
 * @param {array} newComments - list of new comments
 * @returns {array} merged array of new comments
 */


var mergeCommentProperties = function mergeCommentProperties() {
  var currentComments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var newComments = arguments.length > 1 ? arguments[1] : undefined;
  return newComments.map(function (newComment) {
    var currentComment = findItemById(currentComments, newComment.id);
    return currentComment ? _objectSpread(_objectSpread({}, currentComment), newComment) : newComment;
  });
};
/**
 * Reducer to clear context
 * @returns {object} updated state
 */


exports.mergeCommentProperties = mergeCommentProperties;

var contextClear = function contextClear() {
  return INITIAL_STATE;
};
/**
 * Reducer to clear context
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */

/**
 * Reducer to clear existing comments
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsClear = function commentsClear(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentsReceived: false,
    commentsGetting: false,
    comments: [],
    errors: {}
  });
};
/**
 * Reducer to clear an error
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsClearError = function commentsClearError(state, action) {
  var updatedErrors = _objectSpread({}, state.errors);

  delete updatedErrors[action.id];
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: updatedErrors
  });
};
/**
 * Reducer to handle an error on getting comments
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsGetError = function commentsGetError(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentsReceived: false,
    commentsGetting: false,
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, "".concat(_constants.COMMENTS_GET.ERROR, "_").concat(action.error.toUpperCase()))),
    fetching: false
  });
};
/**
 * Reducer to handle starting to get comments
 * @param {object} state - current state of store
 * @returns {object} updated state
 */


var commentsGetStart = function commentsGetStart(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentsReceived: false,
    commentsGetting: true,
    comments: [],
    fetching: true
  });
};
/**
 * Reducer to handle successfully getting comments
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsGetSuccess = function commentsGetSuccess(state, action) {
  var comments = state.comments,
      remappedMap = state.remappedMap;
  var cacheComments = action.cacheComments;
  var assetId = action.assetId;
  var newComments = findAndRemapComments(remappedMap, mergeCommentProperties(comments, action.data));

  if (cacheComments) {
    _LocalStorageManager.default.set(assetId, {
      comments: newComments
    });
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    commentsReceived: true,
    commentsGetting: false,
    commentsUpdated: true,
    comments: newComments,
    errors: {},
    fetching: false
  });
};
/**
 * Reducer to handle getting an error when posting a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsPostError = function commentsPostError(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentPosting: false,
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, "".concat(_constants.COMMENTS_POST.ERROR, "_").concat(action.error.toUpperCase()))),
    commentPosted: false
  });
};
/**
 * Reducer to handle starting to post a comment
 * @param {object} state - current state of store
 * @returns {object} updated state
 */


var commentsPostStart = function commentsPostStart(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentPosted: false,
    commentPosting: true
  });
};
/**
 * Reducer to handle successfully posting a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsPostSuccess = function commentsPostSuccess(state, action) {
  var currentComments = state.comments;
  var cacheComments = action.cacheComments;
  var assetId = action.assetId;
  var nodeId = (0, _lodash.default)(action, 'comment.target.selector.node.id');
  var dirtyComments = nodeId === undefined ? state.dirtyComments : _objectSpread(_objectSpread({}, state.dirtyComments), {}, _defineProperty({}, nodeId, null));

  var newComment = _objectSpread(_objectSpread({}, action.comment), {}, {
    recentActivity: _constants.JUST_ADDED
  });

  newComment.replies = newComment.replies || [];
  var comments = [].concat(_toConsumableArray(currentComments), [newComment]);

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    comments: comments,
    commentPosted: true,
    commentPosting: false,
    commentsUpdated: true,
    dirtyComments: dirtyComments,
    errors: {}
  });
};
/**
 * Reducer to handle proposing a comment to be deleted
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentProposeForDelete = function commentProposeForDelete(state, action) {
  var commentForDelete;

  if (action.parentCommentId) {
    var parentComment = findItemById(state.comments, action.parentCommentId);
    commentForDelete = findItemById(parentComment.replies, action.id);
    commentForDelete.parentCommentId = action.parentCommentId;
  } else {
    commentForDelete = findItemById(state.comments, action.id);
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    commentProposedForDelete: commentForDelete
  });
};
/**
 * Reducer to handle canceling the deletion of a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentCancelForDelete = function commentCancelForDelete(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentProposedForDelete: null
  });
};
/**
 * Reducer to handle failing to delete a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsDeleteError = function commentsDeleteError(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentProposedForDelete: null,
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, _constants.COMMENTS_DELETE.ERROR))
  });
};
/**
 * Reducer to handle successfully deleting a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsDeleteSuccess = function commentsDeleteSuccess(state, _ref) {
  var deletedId = _ref.id,
      parentCommentId = _ref.parentCommentId,
      cacheComments = _ref.cacheComments,
      assetId = _ref.assetId;
  var comments;

  if (parentCommentId) {
    comments = state.comments.map(function (comment) {
      if (comment.id === parentCommentId) {
        return _objectSpread(_objectSpread({}, comment), {}, {
          replies: comment.replies.filter(function (reply) {
            return reply.id !== deletedId;
          })
        });
      }

      return comment;
    });
  } else {
    comments = state.comments.filter(function (comment) {
      return comment.id !== deletedId;
    });
  }

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    commentsUpdated: true,
    comments: comments,
    commentProposedForDelete: null
  });
};
/**
 * Reducer to handle starting to resolve a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsResolveStart = function commentsResolveStart(state, action) {
  var currentComments = state.comments;
  var commentId = action.comment.annotationObject.id;
  var index = currentComments.indexOf(findItemById(currentComments, commentId));
  currentComments[index].status = 'resolved';
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: _toConsumableArray(currentComments)
  });
};
/**
 * Reducer to handle successfully resolving a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsResolveSuccess = function commentsResolveSuccess(state, action) {
  var remappedMap = state.remappedMap;
  var commentId = action.comment.id;
  var cacheComments = action.cacheComments;
  var assetId = action.assetId;
  var updatedCommentData = applyNodeRemap(remappedMap, action.comment);
  var comments = state.comments.map(function (comment) {
    return comment.id === commentId ? updatedCommentData : comment;
  });

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    commentsUpdated: true,
    comments: comments
  });
};
/**
 * Reducer to handle an error resolving a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsResolveError = function commentsResolveError(state, action) {
  var currentComments = state.comments;
  var commentId = action.comment.annotationObject.id;
  var index = currentComments.indexOf(findItemById(currentComments, commentId));
  currentComments[index].status = 'open';
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: _toConsumableArray(currentComments),
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, _constants.COMMENTS_RESOLVE.ERROR))
  });
};
/**
 * Reducer to handle starting to open a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsOpenStart = function commentsOpenStart(state, action) {
  var currentComments = state.comments;
  var commentId = action.comment.annotationObject.id;
  var index = currentComments.indexOf(findItemById(currentComments, commentId));
  currentComments[index].status = 'open';
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: _toConsumableArray(currentComments)
  });
};
/**
 * Reducer to handle successfully opening a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsOpenSuccess = function commentsOpenSuccess(state, action) {
  var currentComments = state.comments;
  var remappedMap = state.remappedMap;
  var commentId = action.comment.id;
  var cacheComments = action.cacheComments;
  var assetId = action.assetId;
  var index = currentComments.indexOf(findItemById(currentComments, commentId));
  var updatedCommentData = applyNodeRemap(remappedMap, action.comment);
  currentComments[index] = updatedCommentData;

  var comments = _toConsumableArray(currentComments);

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    commentsUpdated: true,
    comments: comments
  });
};
/**
 * Reducer to handle an error opening a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsOpenError = function commentsOpenError(state, action) {
  var currentComments = state.comments;
  var commentId = action.comment.annotationObject.id;
  var index = currentComments.indexOf(findItemById(currentComments, commentId));
  currentComments[index].status = 'resolved';
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: _toConsumableArray(currentComments),
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, _constants.COMMENTS_OPEN.ERROR))
  });
};
/**
 * Reducer to set the recenty activity of comment.
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsSetRecentActivity = function commentsSetRecentActivity(state, action) {
  var comments = state.comments;

  for (var idx = 0; idx < comments.length; idx++) {
    var comment = comments[idx]; // if its a reply, apply update to reply.

    if (comment.id === action.parentId && action.replyId) {
      for (var replyIndex = 0; replyIndex < comment.replies.length; replyIndex++) {
        var reply = comment.replies[replyIndex];

        if (reply.id === action.replyId) {
          reply.recentActivity = action.recentActivity;
          break;
        }
      } // apply update comment instead.

    } else if (comment.id === action.parentId && !action.replyId) {
      comment.recentActivity = action.recentActivity;
      break;
    }
  }

  return _objectSpread({}, state);
};
/**
 * Reducer to set show annotations state
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsSetShowAnnotations = function commentsSetShowAnnotations(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showAnnotations: action.showAnnotations
  });
};
/**
 * Reducer to toggle between resolved and unresolved states
 * @param {object} state - current state of store
 * @returns {object} updated state
 */


var commentsToggleResolved = function commentsToggleResolved(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    showResolvedComments: !state.showResolvedComments
  });
};
/**
 * Reducer to clear comments
 * @param {object} state - current state of store
 * @returns {object} updated state
 */


var commentsFilterClear = function commentsFilterClear(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filterTime: [],
    filterUsers: [],
    showResolvedComments: false
  });
};
/**
 * Reducer to set time filters
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsFilterTime = function commentsFilterTime(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filterTime: action.values
  });
};
/**
 * Reducer to set user filters
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsFilterUsers = function commentsFilterUsers(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    filterUsers: action.values
  });
};
/**
 * Reducer to toggle between reply state of comments.
 * @param {Object} state - current state of store
 * @param {Object} action - received action
 * @returns {Object} updated state
 */


var commentsToggleReply = function commentsToggleReply(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: state.comments.map(function (comment) {
      return comment.id === action.id ? _objectSpread(_objectSpread({}, comment), {}, {
        repliesOpen: !!action.draftReplyText || !comment.repliesOpen
      }) : comment;
    })
  });
};
/**
 * Reducer to add dirty state of comment to an artboard before it's been saved
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsAddDirtyCommentToArtboard = function commentsAddDirtyCommentToArtboard(state, action) {
  var dirtyComments = state.dirtyComments || {};
  dirtyComments[action.artboardID] = dirtyComments[action.artboardID] || {};

  if (typeof action.comment === 'string') {
    dirtyComments[action.artboardID].bodyValue = action.comment;
  } // this will be set to null when user is typing but annotation location will be saved correctly when switching artboards


  dirtyComments[action.artboardID].location = action.location;
  return _objectSpread(_objectSpread({}, state), {}, {
    dirtyComments: dirtyComments
  });
};
/**
 * Reducer to handle starting to edit a comment.
 * @param {Object} state - current state of store
 * @param {Object} action - received action
 * @returns {Object} updated state
 */


var commentsEditStart = function commentsEditStart(state, _ref2) {
  var id = _ref2.id,
      parentCommentId = _ref2.parentCommentId;
  return _objectSpread(_objectSpread({}, state), {}, {
    editingCommentId: id,
    editingReplyId: parentCommentId && id,
    editingReplyParentCommentId: parentCommentId
  });
};
/**
 * Reducer to handle getting an error when editing a comment
 * @param {Object} state - current state of store
 * @param {Object} action - received action
 * @returns {Object} updated state
 */


var commentsEditError = function commentsEditError(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    editingCommentId: INITIAL_STATE.editingCommentId,
    editingReplyId: INITIAL_STATE.editingReplyId,
    editingReplyParentCommentId: INITIAL_STATE.editingReplyParentCommentId,
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, _constants.COMMENTS_EDIT.ERROR))
  });
};
/**
 * Reducer to handle successfully editing a comment
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsEditSuccess = function commentsEditSuccess(state, action) {
  var currentComments = state.comments;
  var remappedMap = state.remappedMap;
  var updatedCommentData = action.updatedCommentData;
  var parentCommentId = action.parentCommentId;
  var cacheComments = action.cacheComments;
  var assetId = action.assetId;
  updatedCommentData.recentActivity = _constants.JUST_EDITED;
  updatedCommentData = applyNodeRemap(remappedMap, updatedCommentData); // if parent comment exists, modify replies comment array to have edited replied comment

  if (parentCommentId) {
    var parentComment = findItemById(currentComments, parentCommentId);
    parentComment.replies.splice(parentComment.replies.indexOf(findItemById(parentComment.replies, updatedCommentData.id)), 1, updatedCommentData);
    currentComments.splice(currentComments.indexOf(findItemById(currentComments, parentComment.id)), 1, parentComment);
  } else {
    currentComments.splice(currentComments.indexOf(findItemById(currentComments, updatedCommentData.id)), 1, updatedCommentData);
  }

  var comments = _toConsumableArray(currentComments);

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    commentsUpdated: true,
    comments: comments,
    editingCommentId: INITIAL_STATE.editingCommentId,
    editingReplyId: INITIAL_STATE.editingReplyId,
    editingReplyParentCommentId: INITIAL_STATE.editingReplyParentCommentId,
    errors: {}
  });
};
/**
 * Reducer to update the scroll position by node.
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsRemapCommentNode = function commentsRemapCommentNode(state, action) {
  var comments = state.comments,
      remappedMap = state.remappedMap;
  var mappingData = action.mappingData;
  var updatedComments = comments;
  Object.keys(mappingData).forEach(function (commentId) {
    var nodeId = mappingData[commentId];

    if (commentId && nodeId !== undefined) {
      if (remappedMap[commentId]) {
        remappedMap[commentId].current = nodeId;
      } else {
        var matchedComment = findItemById(updatedComments, commentId);

        if (matchedComment) {
          remappedMap[commentId] = {
            original: matchedComment.target.selector.node.id,
            current: nodeId
          };
        }
      }

      updatedComments = findAndRemapComments(remappedMap, updatedComments);
    }
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: updatedComments,
    remappedMap: remappedMap
  });
};
/**
 * Reducer to handle successfully updating an annotation.
 * @param {Object} state - current state of store
 * @param {Object} action - received action
 * @return {Object} updated state
 */


var updateAnnotationSuccess = function updateAnnotationSuccess(state, action) {
  var comments = state.comments,
      remappedMap = state.remappedMap;
  var updatedComment = applyNodeRemap(remappedMap, action.updatedComment);
  updatedComment.recentActivity = _constants.JUST_EDITED;
  return _objectSpread(_objectSpread({}, state), {}, {
    commentsUpdated: true,
    comments: comments.map(function (comment) {
      return comment.id === updatedComment.id ? updatedComment : comment;
    }),
    errors: {}
  });
};
/**
 * Reducer to handle an error on updating an annotation.
 * @param {Object} state - current state of store
 * @param {Object} action - received action
 * @return {Object} updated state
 */


var updateAnnotationError = function updateAnnotationError(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, _constants.UPDATE_ANNOTATION.ERROR))
  });
};
/**
 * Reducer to handle starting of post a reply.
 * @param {object} state - current state of store
 * @param {Object} action - received action
 * @returns {object} updated state
 */


var postReplyStart = function postReplyStart(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentPosting: true,
    postingReplyParentCommentId: action.parentCommentId
  });
};
/**
 * Reducer to handle successfully posting a reply.
 * @param {Object} state - current state of store
 * @param {Object} action - received action
 * @returns {Object} updated state
 */


var postReplySuccess = function postReplySuccess(state, action) {
  var comments = state.comments,
      _state$dirtyComments = state.dirtyComments,
      dirtyComments = _state$dirtyComments === void 0 ? {} : _state$dirtyComments;
  var nodeId = (0, _lodash.default)(action, 'comment.target.selector.node.id');
  var assetId = action.assetId,
      cacheComments = action.cacheComments,
      parentCommentId = action.parentCommentId,
      reply = action.reply;

  if (nodeId) {
    dirtyComments[nodeId] = null;
  }

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  var newComments = comments.map(function (comment) {
    if (comment.id === parentCommentId) {
      return _objectSpread(_objectSpread({}, comment), {}, {
        replies: [].concat(_toConsumableArray(comment.replies), [_objectSpread(_objectSpread({}, reply), {}, {
          recentActivity: _constants.JUST_ADDED
        })])
      });
    }

    return comment;
  });
  return _objectSpread(_objectSpread({}, state), {}, {
    dirtyComments: dirtyComments,
    comments: newComments,
    commentPosting: false,
    commentsUpdated: true,
    errors: {},
    postingReplyParentCommentId: INITIAL_STATE.postingReplyParentCommentId
  });
};
/**
 * Reducer to handle an error on posting a reply.
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var postReplyError = function postReplyError(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    commentPosting: false,
    errors: _objectSpread(_objectSpread({}, state.errors), {}, _defineProperty({}, action.error, "".concat(_constants.POST_REPLY.ERROR, "_").concat(action.error.toUpperCase()))),
    postingReplyParentCommentId: INITIAL_STATE.postingReplyParentCommentId
  });
};
/**
 * Reducer to handle successfully batch remapping comments
 * @param {object} state - current state of store
 * @param {object} action - received action
 * @returns {object} updated state
 */


var commentsBatchRemapSuccess = function commentsBatchRemapSuccess(state, action) {
  var currentComments = state.comments;
  var commentsToUpdate = action.commentsToUpdate;
  var assetId = action.assetId;
  var cacheComments = action.cacheComments;

  var comments = _toConsumableArray(currentComments);

  commentsToUpdate.forEach(function (updatedCommentData) {
    var commentIndex = comments.indexOf(findItemById(comments, updatedCommentData.id));

    if (commentIndex !== -1) {
      comments.splice(commentIndex, 1, updatedCommentData);
    }
  });

  if (cacheComments) {
    var cachedCommentsData = _LocalStorageManager.default.get(assetId);

    if (cachedCommentsData) {
      _LocalStorageManager.default.set(assetId, {
        comments: comments
      });
    }
  }

  return _objectSpread(_objectSpread({}, state), {}, {
    comments: comments,
    commentsUpdated: true,
    remappedMap: {}
  });
};

var forceCommentUpdateIfRequired = function forceCommentUpdateIfRequired(state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    comments: state.comments.map(function (comment) {
      var _comment$target, _comment$target$selec, _comment$target2, _comment$target2$sele;

      if ((_comment$target = comment.target) !== null && _comment$target !== void 0 && (_comment$target$selec = _comment$target.selector) !== null && _comment$target$selec !== void 0 && _comment$target$selec.subtype && ((_comment$target2 = comment.target) === null || _comment$target2 === void 0 ? void 0 : (_comment$target2$sele = _comment$target2.selector) === null || _comment$target2$sele === void 0 ? void 0 : _comment$target2$sele.subtype) !== 'node') {
        return _objectSpread({}, comment);
      }

      return comment;
    })
  });
};

var _default = (0, _reduxActions.handleActions)((_handleActions = {}, _defineProperty(_handleActions, _constants.CONTEXT_CLEAR, contextClear), _defineProperty(_handleActions, _constants.COMMENTS_BATCH_REMAP.SUCCESS, commentsBatchRemapSuccess), _defineProperty(_handleActions, _constants.COMMENTS_CLEAR, commentsClear), _defineProperty(_handleActions, _constants.COMMENTS_CLEAR_ERROR, commentsClearError), _defineProperty(_handleActions, _constants.COMMENTS_DELETE.ERROR, commentsDeleteError), _defineProperty(_handleActions, _constants.COMMENTS_DELETE.SUCCESS, commentsDeleteSuccess), _defineProperty(_handleActions, _constants.COMMENTS_GET.ERROR, commentsGetError), _defineProperty(_handleActions, _constants.COMMENTS_GET.START, commentsGetStart), _defineProperty(_handleActions, _constants.COMMENTS_GET.SUCCESS, commentsGetSuccess), _defineProperty(_handleActions, _constants.COMMENTS_POST.ERROR, commentsPostError), _defineProperty(_handleActions, _constants.COMMENTS_POST.START, commentsPostStart), _defineProperty(_handleActions, _constants.COMMENTS_POST.SUCCESS, commentsPostSuccess), _defineProperty(_handleActions, _constants.COMMENTS_RESOLVE.START, commentsResolveStart), _defineProperty(_handleActions, _constants.COMMENTS_RESOLVE.SUCCESS, commentsResolveSuccess), _defineProperty(_handleActions, _constants.COMMENTS_RESOLVE.ERROR, commentsResolveError), _defineProperty(_handleActions, _constants.COMMENTS_OPEN.START, commentsOpenStart), _defineProperty(_handleActions, _constants.COMMENTS_OPEN.SUCCESS, commentsOpenSuccess), _defineProperty(_handleActions, _constants.COMMENTS_OPEN.ERROR, commentsOpenError), _defineProperty(_handleActions, _constants.COMMENTS_CANCEL_FOR_DELETE, commentCancelForDelete), _defineProperty(_handleActions, _constants.COMMENTS_PROPOSE_FOR_DELETE, commentProposeForDelete), _defineProperty(_handleActions, _constants.COMMENTS_FILTER_CLEAR, commentsFilterClear), _defineProperty(_handleActions, _constants.COMMENTS_FILTER_TIME, commentsFilterTime), _defineProperty(_handleActions, _constants.COMMENTS_FILTER_USERS, commentsFilterUsers), _defineProperty(_handleActions, _constants.COMMENTS_SET_RECENT_ACTIVITY, commentsSetRecentActivity), _defineProperty(_handleActions, _constants.COMMENTS_SET_SHOW_ANNOTATIONS, commentsSetShowAnnotations), _defineProperty(_handleActions, _constants.COMMENTS_TOGGLE_RESOLVED, commentsToggleResolved), _defineProperty(_handleActions, _constants.COMMENTS_TOGGLE_REPLY, commentsToggleReply), _defineProperty(_handleActions, _constants.COMMENTS_ADD_DIRTY_COMMENT_TO_ARTBOARD, commentsAddDirtyCommentToArtboard), _defineProperty(_handleActions, _constants.COMMENTS_EDIT.START, commentsEditStart), _defineProperty(_handleActions, _constants.COMMENTS_EDIT.ERROR, commentsEditError), _defineProperty(_handleActions, _constants.COMMENTS_EDIT.SUCCESS, commentsEditSuccess), _defineProperty(_handleActions, _constants.COMMENTS_REMAP_COMMENT_NODES, commentsRemapCommentNode), _defineProperty(_handleActions, _constants.CONTEXT_REGISTER_SECTION_ID, forceCommentUpdateIfRequired), _defineProperty(_handleActions, _constants.UPDATE_ANNOTATION.SUCCESS, updateAnnotationSuccess), _defineProperty(_handleActions, _constants.UPDATE_ANNOTATION.ERROR, updateAnnotationError), _defineProperty(_handleActions, _constants.POST_REPLY.START, postReplyStart), _defineProperty(_handleActions, _constants.POST_REPLY.SUCCESS, postReplySuccess), _defineProperty(_handleActions, _constants.POST_REPLY.ERROR, postReplyError), _handleActions), INITIAL_STATE);

exports.default = _default;